import React from 'react';
import './App.css';
import JSSB from './ContactForm'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <JSSB />
      </header>
    </div>
  );
}

export default App;
